import { backgroundTransitionOnClick, flex, IconFont, pointer, singleTextEllipsis } from '@byecode/ui'
import styled from 'styled-components'

export const ButtonContainer = styled.div`
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 8px;
    border: 1px solid var(--color-gray-200);
`
export const Header = styled.div`
    ${flex}
    padding: 12px 8px;
    justify-content: space-between;
    background-color: var(--color-gray-100);
    gap: 8px;
`

export const LeftFill = styled.div`
    /* width: 126px; */
    ${flex}
    align-items: center;
    overflow: hidden;
    flex: 1;
`

export const RightFill = styled.div`
    width: 180px;
    /* max-width: 80%; */
    ${flex}
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
`
export const Handle = styled.div`
    /* padding: 4px; */
    ${flex}
    align-items: center;
`

export const Title = styled.span`
    padding-left: 4px;
    line-height: 16px;
    color: var(--color-black);
    font-style: normal;
    font-weight: 400;
    word-break: break-word;
    font-size: var(--font-size-normal);
    flex: 1;
    ${singleTextEllipsis}
`
export const Content = styled.div`
    margin: 8px 0;
`
